const iconClass = "h-7 w-7 text-personalized";

const BondaIcon = () => (
  <svg className={iconClass} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M12 3 4.5 7.5v9L12 21l7.5-4.5v-9L12 3Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
    <path d="m9.5 12 1.5 1.5 3.8-4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6.5 5.8 5 4.3M17.5 5.8 19 4.3M6.5 18.2 5 19.7M17.5 18.2l1.5 1.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

const CourseIcon = () => (
  <svg className={iconClass} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M5 4.5h14v15H5v-15Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
    <path d="M8 8h5M8 11h8M8 14h6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

const TripIcon = () => (
  <svg className={iconClass} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M4 10h16v10H4V10Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
    <path d="M4 10h16M12 10v10M7.5 10C6 9.5 5.3 8.2 6 7.2c.8-1.1 2.5-.7 3.4.7L12 10l2.6-2.1c.9-1.4 2.6-1.8 3.4-.7.7 1-.1 2.3-1.5 2.8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const getExchangeIcon = (title = "") => {
  const normalizedTitle = title.toLowerCase();
  if (normalizedTitle.includes("bonda")) return <BondaIcon />;
  if (normalizedTitle.includes("curso")) return <CourseIcon />;
  if (normalizedTitle.includes("uc") || normalizedTitle.includes("viaje")) return <TripIcon />;
  return <BondaIcon />;
};

const formatDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString("es-CO", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
};

const ExchangeCard = ({ exchange, showDescription = true }) => {
  const title = exchange.productTitle || "Canje";
  const exchangeDate = formatDate(exchange.exchangeDate);
  const compact = !showDescription;

  return (
    <article className={`${compact ? 'min-h-[4.25rem] px-3 py-2' : 'min-h-[7rem] px-3 py-3 sm:px-4 lg:min-h-[6.25rem] xl:py-3'} overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm`}>
      <div className={`flex h-full flex-row items-center ${compact ? 'gap-2' : 'gap-3'}`}>
        <div className={`${compact ? 'h-9 w-9' : 'h-12 w-12'} flex shrink-0 items-center justify-center`}>
          {getExchangeIcon(title)}
        </div>
        <div className="min-w-0 flex-1">
          <h3 className={`${compact ? 'text-sm leading-tight' : 'text-sm sm:text-base lg:text-sm xl:text-base'} font-semibold text-gray-900 break-words`}>
            {title}
          </h3>
          {showDescription && exchange.productDescription && (
            <p className="text-sm text-gray-500 break-words sm:text-sm lg:text-xs xl:text-sm">
              {exchange.productDescription}
            </p>
          )}
          {exchangeDate && (
            <p className={`${compact ? 'mt-0 text-[11px]' : 'mt-0.5 text-xs'} leading-tight text-gray-500`}>
              Fecha: {exchangeDate}
            </p>
          )}
        </div>
        <div className={`${compact ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-xs sm:px-3 sm:text-sm'} w-fit shrink-0 rounded-md border border-orange-300 bg-orange-50 font-semibold text-orange-700 sm:ml-auto`}>
          -{exchange.exchangeScore} pts
        </div>
      </div>
    </article>
  );
};

export default ExchangeCard;
